import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import UserContext from '../../../context/UserContext';
import useForm from '../../../hooks/useForm';
import Button from '../../shared/Button';
import Input from '../../shared/Input';
import Box from '../../shared/layouts/Box';
import Cluster from '../../shared/layouts/Cluster';
import Labeled from '../../shared/WithLabel';
import LoginContainer from './LoginContainer';
import {useTranslation} from "react-i18next";
import {sendDataToReactNative} from "../../../utils/communicateWithRN";

const Mfa = () => {
  const navigate = useNavigate();
  const [state, handleState] = useForm({ mfa_input: '' });
  const { multipleDossiers } = useContext(WhiteLabelContext);
  const { logoutUser, initPathname, user } = useContext(UserContext);
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post('/multifactor/authenticate', state, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(() => {
        // NOTE: if user is null we lost the user context and can't use dossier-select or navigate.
        // This is an edge-case and will resolve itself after login due to the AuthenticadedLayout in App.js when multi-dossier is enabled
        if (!user) {
          window.location.href = initPathname ? initPathname.pathname : '/dashboard';
          return;
        }

        if (multipleDossiers && !user.dossier) {
          navigate('/dossier-select');
        } else {
          navigate(initPathname ? initPathname : '/dashboard');
        }
      })
      .catch(({ response }) => {
        let errors = response.response?.data?.errors ?? {};

        if (response.status === 401) {
          errors = { mfa_input: [t('Code incorrect')] };
        }

        sendDataToReactNative(JSON.stringify(errors));
        setErrors(errors);
      });
  };

  useEffect(() => {
    axios
      .get('multifactor/choose/otp')
      .catch(console.error);
  }, []);

  return (
    <LoginContainer width={{ sm: '21.5rem', ml: '27.5rem'}} handleSubmit={handleSubmit} hideUwKluisLogo>
      <Box fontScale="2xl" fontWeight="bold">
        {t('Bevestig jouw inlog')}
      </Box>
      <Box>
        {t('Voer jouw authenticatie code in die je terug kan vinden in je gekoppelde authenticatie-app')}
      </Box>
      <Labeled label={t("Voer jouw code in")}>
        <Input
          name="mfa_input"
          value={state.mfa_input}
          onChange={handleState}
          errors={errors?.mfa_input}
        />
      </Labeled>
      <Link
        to="/switch-mfa"
        css={(theme) => ({
          fontSize: theme.fontSizes.s,
          marginTop: theme.space.m,
          textDecoration: 'underline',
          color: theme.colors.primary,
          fontWeight: 'bold',
        })}
      >
        {t('Inloggen op een andere manier')}
      </Link>
      <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
        <Button
          variant="primary-outline"
          onClick={logoutUser}
        >
          {t('Annuleren')}
        </Button>
        <Button variant="primary" type="submit">
          {t('Inloggen')}
        </Button>
      </Cluster>
    </LoginContainer>
  );
};
export default Mfa;
